import type { RecaptionPrompt } from '@/app/types';
import { stringifyTextPromptWithReference } from './text-prompt-with-reference';

/**
 * 检查 recaptionPrompt 的所有必填 key
 * @param recaptionPrompt
 * @returns 如果 recaptionPrompt 的所有必填 key 都存在且不为空，则返回 true，否则返回 false
 */
export const validateRecaptionPrompt = (recaptionPrompt?: RecaptionPrompt) => {
  if (!recaptionPrompt) {
    return false;
  }

  const { subject, environment, style, motionLevel } = recaptionPrompt;

  if (!subject?.length || !environment?.length || !style?.length || !motionLevel?.length) {
    return false;
  }

  // stringify subject 和 environment 来判断，忽略 mention 节点
  if (
    !stringifyTextPromptWithReference(subject, true)?.length ||
    !stringifyTextPromptWithReference(environment, true)?.length
  ) {
    return false;
  }

  return true;
};
